import { URLState } from '../../../models';
import { URL_GETTERS_KEYS } from '../url.const';
import { URLGetter } from '../url.interfaces';

export class URLObjectGetter implements URLGetter {

  getters = {
    [URL_GETTERS_KEYS.url]: (urlState: URLState): URL => new URL(urlState.url)
  };
}
